const SvgSucces = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
    <path d="m24.497 9.333-10.139 9.328-5.523-5.067-2.169 1.996 7.692 7.077 12.308-11.323-2.169-2.01z" />
  </svg>;
export default SvgSucces;